import { render, staticRenderFns } from "./CompensationStatusSelector.vue?vue&type=template&id=1048c4c7&scoped=true&"
import script from "./CompensationStatusSelector.vue?vue&type=script&lang=js&"
export * from "./CompensationStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1048c4c7",
  null
  
)

export default component.exports